'use client'

import { useTranslations } from 'next-intl'
import { useRouter } from '@/i18n/routing'
import { useVideoCompressorStore } from '@/stores/use-video-compressor-store'
import { FileDropZone } from '@/components/shared/FileDropZone'
import { ToolStepIndicator } from '@/components/shared/ToolStepIndicator'
import { trackToolEvent } from '@/lib/utils/analytics'

export function VideoUploadStep() {
    const t = useTranslations('Upload')
    const router = useRouter()
    const addFiles = useVideoCompressorStore(s => s.addFiles)
    const reset = useVideoCompressorStore(s => s.reset)

    const handleFilesAdded = (files: File[]) => {
        reset()
        const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mkv', '.mov', '.avi']
        const isVideo = (f: File) => {
            if (f.type.startsWith('video/')) return true
            const ext = '.' + f.name.split('.').pop()?.toLowerCase()
            return VIDEO_EXTENSIONS.includes(ext)
        }
        addFiles(files, isVideo)
        const accepted = files.filter(isVideo)
        if (accepted.length > 0) {
            trackToolEvent('tool_upload_started', {
                tool: 'video-compressor',
                file_count: accepted.length,
                file_kind: 'video',
            })
        }
        router.push('/compress-video/configurar')
    }

    return (
        <div className="mx-auto max-w-4xl">
            <ToolStepIndicator currentStep={1} baseUrl="/compress-video" />
            <div className="rounded-3xl bg-white p-4 shadow-2xl shadow-slate-200/50">
                <FileDropZone
                    accept="video/*,.mkv,.avi"
                    icon="movie"
                    title={t('selectVideos')}
                    subtitle={t('subtitleVideo')}
                    onFilesAdded={handleFilesAdded}
                />
            </div>
        </div>
    )
}
